module.exports = __webpack_public_path__ + "static/media/main idea.12b7ac6e.mp3";